import script from "./UserResetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./UserResetPassword.vue?vue&type=script&setup=true&lang=js"

import "./UserResetPassword.vue?vue&type=style&index=0&id=49a9867d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49a9867d"]])

export default __exports__